import React, { useEffect } from "react";
import styled from "styled-components";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "../../components/header/header";
import Hero from "./hero";
import SelectExam from "./exam";
import ExamPrep from "./exam-prep";
import StudyAnywhere from "./study-anywhere";
import HighExam from "./high-exam";
import TrackPerformance from "./track-performance";
import StudyExperience from "./study-experience";
import Testimonials from "./testimonials";
import Subscriptions from "./subscriptions";
import FAQ from "./faq";
import Banner from "./banner";
import Footer from "../../components/footer/footer";
import { useUserContext } from "../../context/user-context";
import { useLocation } from "react-router-dom";

const Home = () => {
  useEffect(() => {
    //@ts-ignore
    gtag("event", "sign-up", {
      send_to: "AW-11358620077/zywSCO_HufUZEK2Tm6gq",
      transaction_id: ""
    });
  }, []);

  const { pathname, search } = useLocation();

  const { userState, setStateUserState } = useUserContext();

  let query = new URLSearchParams(search);
  let referrer = query.get("ref");
  console.log(query.get("ref"));

  if (userState?.attributes?.referrer != referrer && referrer) {
    setStateUserState(prev => ({
      ...prev,
      attributes: { ...prev.attributes, referrer }
    }));
  }

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false,
      easing: "ease-in-out",
      mirror: false,
      offset: 120,
      anchorPlacement: "top-center",
      disable: false
    });

    window.addEventListener("scroll", () => {
      AOS.refresh();
    });

    return () => {
      window.removeEventListener("scroll", () => {
        AOS.refresh();
      });
    };
  }, []);

  return (
    <HomeContainer>
      <HeroWrapper>
        <Header />
        <Hero />
      </HeroWrapper>
      <MadeBy
        src="/assets/home/a.png"
        alt="Medical students studying"
        data-aos="zoom-in"
        data-aos-duration="1000"
      />
      <HomeWrapper>
        <SelectExam />
        <ExamPrep />
        <StudyAnywhere />
        <TrackPerformance />
        <HighExam />
        <StudyExperience />
        <Testimonials />
      </HomeWrapper>
      <Subscriptions />
      <HomeWrapper>
        <FAQ />
        <Banner />
      </HomeWrapper>
      <Footer data-aos="fade-up" data-aos-duration="800" />
    </HomeContainer>
  );
};

const HomeContainer = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const HomeWrapper = styled.div`
  background-color: #f9fbff;
  padding-bottom: 80px;
`;

const HeroWrapper = styled.div`
  position: relative;
  overflow: hidden;
  // background-color: #f9fbff;
`;

const MadeBy = styled.img.attrs({
  loading: "eager" as const
})`
  width: 145px !important;
  height: 152px !important;
  position: absolute;
  right: -30px;
  top: 630px;

  @media (min-width: 768px) {
    width: 184px !important;
    height: 194px !important;
    right: 270px;
    top: 530px;
    margin-bottom: 2.5rem;
  }
`;
export default Home;
